import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import CommonTable, { CommonTableProps } from "components/CommonTable";
import {
  addNomination,
  deleteNomination,
  fetchNomination,
  updateNomination,
} from "redux/actions/nomination";
import NominationRes from "types/res/nomination/NominationRes";
import { fetchShops } from "redux/actions/shop";
import { FormType } from "components/FormField";
import CreateNominationReq from "types/req/nomination/CreateNominationReq";
import UpdateNominationReq from "types/req/nomination/UpdateNominationReq";

const Nomination: React.FC = () => {
  const { t } = useTranslation("master");
  const dispatch = useDispatch();
  const companyId = useSelector((state) => state.account.staff.companyId);
  const nomination = useSelector((state) => state.nomination);

  useEffect(() => {
    dispatch(fetchShops(companyId));
    dispatch(fetchNomination(companyId));
  }, [companyId, dispatch]);

  const headers: { key: keyof NominationRes; label: string }[] = [
    { key: "name", label: t("nomination.headers.name") },
    { key: "totalFee", label: t("nomination.headers.totalFee") },
    { key: "shopFee", label: t("nomination.headers.shopFee") },
    { key: "castFee", label: t("nomination.headers.castFee") },
  ];

  const forms = [
    {
      label: t("nomination.forms.name"),
      key: "name",
      type: FormType.Text,
    },
    {
      label: t("nomination.forms.totalFee"),
      key: "totalFee",
      type: FormType.Number,
    },
    {
      label: t("nomination.forms.shopFee"),
      key: "shopFee",
      type: FormType.Number,
    },
    {
      label: t("nomination.forms.castFee"),
      key: "castFee",
      type: FormType.Number,
    },
  ];

  return (
    <>
      <NominationTable
        title={t("nomination.title")}
        formId="nominationForm"
        forms={forms}
        rows={headers}
        data={nomination}
        addFunc={(formData) => addNomination(companyId, formData)}
        updateFunc={(formData) => updateNomination(companyId, formData)}
        deleteFunc={(item) =>
          deleteNomination(companyId, {
            nominationId: item.nominationId,
          })
        }
        addType={CreateNominationReq}
        updateType={UpdateNominationReq}
        values={[
          (s) => s.name,
          (s) => s.totalFee,
          (s) => s.shopFee,
          (s) => s.castFee,
        ]}
      />
    </>
  );
};

const NominationTable = styled<
  React.FC<
    CommonTableProps<NominationRes, CreateNominationReq, UpdateNominationReq>
  >
>(CommonTable)`
  margin-top: 24px;
`;

export default Nomination;
